<template>
  <div>
    <!-- 封面 -->
    <div id="01"></div>
    <a-row class="cover">
      <a-col
        class="container"  style="text-align:center"
        :xs="{ span: 24, offset: 0 }"
        :xxl="{ span: 16, offset: 4 }"
      >
        <img class="cover-title" src="~@/assets/real-name-assistant/direction/cover_title.png" alt="cover_title">
        <h1 class="title-level1" style="font-weight:normal;color:#333">使用说明简介</h1>
        <img class="page-logo" src="~@/assets/logo_blue.png" alt="logo_blue">
      </a-col>
    </a-row>

    <!-- 使用视频 -->
    <!-- <a-row class="video">
      <a-col
        class="container"
        :xs="{ span: 24, offset: 0 }"
        :xxl="{ span: 16, offset: 4 }"
      >
        <div style="padding: 30px 0">
          <h2 class="title-level2" style="text-align:center;color:#333">视频简介</h2>
          <video
            src="~@/assets/real-name-assistant/direction/video.mp4"
            controls="controls" width="100%" style="border: none;"
          >
            您的浏览器不支持 video 标签！
          </video>
        </div>
      </a-col>
    </a-row> -->

    <a-row
      v-for="section in datas" :key="section.key"
      class="direction" :id="section.key"
      :style="{'background-image': `url(${require(`@/assets/real-name-assistant/direction/${section.bgPic}`)})`}"
    >
      <a-col
        class="container"
        :xs="{ span: 24, offset: 0 }"
        :xxl="{ span: 16, offset: 4 }"
      >
        <!-- 版块标题 -->
        <h2 class="section-title title-level2">{{section.title}}</h2>
        <p v-if="section.desc" class="text-level1">{{section.desc}}</p>

        <div class="content">
          <div v-for="(item, index) in section.contents" :key="index">
            <!-- 内容标题 -->
            <div class="title-level3">
              <span class="sub-title">{{item.title}}</span>
            </div>
            <!-- 内容 -->
            <div v-for="(desc, index) in item.descs" :key="index">
              <!-- 文字内容 -->
              <div class="describe" v-if="desc.text">
                <div class="dot">{{index + 1}}</div>
                <div class="text text-level1">{{desc.text}}</div>
              </div>
              <!-- 警告框 -->
              <div class="warning" v-if="desc.warnings && desc.warnings.length">
                <div class="head">
                  <img src="~@/assets/real-name-assistant/direction/icon_deng.png" alt="icon_deng">
                  <span>注意：</span>
                </div>
                <div class="content">
                  <!-- 警告项 -->
                  <div v-for="(warn, index) in desc.warnings" :key="index">
                    <!-- 警告文字 -->
                    <p>{{warn.text}}</p>
                    <!-- 警告配图 -->
                    <template v-if="warn.pics && warn.pics.length">
                      <img
                        v-for="(pic, index) in warn.pics" :key="index"
                        class="picture"
                        :src="require(`@/assets/real-name-assistant/direction/${pic}`)" :alt="pic"
                      >
                    </template>
                  </div>
                </div>
              </div>
              <!-- 文字内容配图 -->
              <a-row class="picture-group" :gutter="24" v-if="desc.pics && desc.pics.length">
                <a-col
                  v-for="pic in desc.pics" :key="pic.name"
                  :xs="pic.span.xs" :lg="pic.span.lg">
                  <img class="picture" :src="require(`@/assets/real-name-assistant/direction/${pic.name}`)" :alt="pic.name">
                </a-col>
              </a-row>
            </div>
          </div>
        </div>
      </a-col>
    </a-row>

    <PageFooter />
  </div>
</template>

<script>
import PageFooter from '../components/PageFooter.vue'
import datas from './datas.json'

export default {
  name: 'RealNameAssistant-Direction',
  components: { PageFooter },
  data () {
    return {
      datas
    }
  },
  computed: {},
  methods: {}
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
